import { type Dispatch, type SetStateAction, useState } from 'react';

import { v4 as uuid } from 'uuid';

import { PAGE_FLOW } from '../constants';

import type { Nullable, PageFlow } from '../types';

const generateActionId = () => `web1${uuid().toUpperCase()}`;

const useActionId = (
  actionIdProp: Nullable<string>,
  isOpen: boolean,
  setPageFlow: Dispatch<SetStateAction<PageFlow>>,
): string => {
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);
  const [actionId, setActionId] = useState(() => actionIdProp ?? generateActionId());

  if (prevIsOpen !== isOpen) {
    setPrevIsOpen(isOpen);
    if (isOpen) {
      setActionId(actionIdProp ?? generateActionId());
      setPageFlow(PAGE_FLOW.INTRO);
    }
  }

  return actionId;
};

export default useActionId;
